<template>
  <div class="pc_home-content" v-if="isMaxScreen">
    <template v-if="blogList.length > 0">
      <div class="blog-list">
        <div class="blog-list-item" v-for="(item, index) in blogList" @click="linkDetail(item.id)">
          <el-image :src="item.picture" class="blog-list-item-image">
            <div slot="error">
              <img src="@/assets/image/eu-home/blog-default.png" class="blog-list-item-image" />
            </div>
          </el-image>
          <div class="blog-list-item-right">
            <div class="item-right-title">
              {{ item.title }}
            </div>
            <div class="item-right-content" v-html="item.content"></div>
            <div class="item-right-time-view">
              {{ formattedDate(item.publishTime) }} &nbsp | &nbsp {{ item.views }} {{$t('blog.blogList.64wgr171lsk0')}}
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-div">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>
    <template v-else>
      <div class="empty-image-box">
        <img src="@/assets/image/eu-home/empty.png" alt="" class="empty-image" />
        <span>{{$t('blog.blogList.64wgr171nq40')}}</span>
      </div>
    </template>
  </div>
  <div class="home-content" v-else>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="--End--"
      @load="onLoad"
      class="blog-list"
      v-if="blogList.length > 0"
    >
      <div class="blog-list-item" v-for="(item, index) in blogList" @click="linkDetail(item.id)">
        <el-image
          :src="item.picture"
          error="@/assets/image/eu-home/blog-default.png"
          class="blog-list-item-image"
        >
          <template slot="error">
            <img src="@/assets/image/eu-home/blog-default.png" class="blog-list-item-image" />
          </template>
        </el-image>
        <div class="blog-list-item-right">
          <div class="item-right-title">
            {{ item.title }}
          </div>
          <div class="item-right-time-view">
            {{ item.views }} {{$t('blog.blogList.64wgr171lsk0')}} {{ formattedDate(item.publishTime) }}
          </div>
        </div>
      </div>
      <!-- <div class="end">-- End --</div> -->
    </van-list>
    <div class="empty-image-box" v-else>
      <img src="@/assets/image/eu-home/empty.png" alt="" class="empty-image" />
      <span>{{$t('blog.blogList.64wgr171nq40')}}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isES } from '@/locales';
import { getBlogList, getBlogDetail } from '@/services/api/home';
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      isES,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      blogList: [],
      loading: false,
      finished: false
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  created() {
    this.$nextTick(() => {
      this.getBlogList();
    });
  },
  methods: {
    formattedDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    onLoad() {
      console.log(this.blogList.length,  this.total)
      if(this.blogList.length < this.total){
        this.currentPage = this.currentPage + 1
        this.getBlogList();
      }else{
        this.finished = true
      }
      
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBlogList();
    },
    /**
     * 获取机型列表
     */
    getBlogList() {
      console.log(this.isMaxScreen);
      let data = {
        channelId: 100000,
        nation: 'ES',
        pageIndex: this.currentPage,
        pageSize: this.pageSize
      };

      getBlogList(data).then(res => {
        let { code, data } = res;
        if (code === '0000') {
          this.loading = false
          this.total = data.total;
          if(this.isMaxScreen){
            this.blogList = data.list;
          }else{
            this.blogList = this.blogList.concat(data.list)
          }
        }
      });
    },
    linkDetail(id) {
      this.$router.push({
        name: 'BlogDetail',
        query: {
          id
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .pc_home-content {
    background: #f7f7f7;
    margin-top: 140px;
    overflow: hidden;
    .blog-list {
      padding: 40px 40px 0;
      box-sizing: border-box;
      width: 1240px;
      margin: 0 auto;
      border-radius: 12px;
      background-color: #fff;
      overflow: hidden;
    }

    .empty-image-box {
      width: 300px;
      text-align: center;
      margin: 290px auto 300px;
      img {
        width: 160px;
        height: 160px;
      }
      span {
        display: block;
        color: var(---Text-1, #252629);
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 100% */
      }
    }

    .pagination-div {
      margin-top: 40px;
      margin-bottom: 80px;
      display: flex;
      justify-content: center;

      /deep/.el-pagination__editor {
        margin: 0 8px;
      }

      /deep/ .el-pager .number {
        background-color: #fff;
      }
      /deep/ .el-pagination.is-background {
        .btn-prev,
        .btn-next {
          background-color: #fff;
        }
      }
      /deep/ .el-pagination.is-background .el-pager li {
        &:hover {
          background-color: #405FFF;
          color: #fff;
        }
      }
      /deep/ .el-pagination__editor.el-input .el-input__inner {
        &:focus {
          border-color: #405FFF;
        }
      }
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #405FFF;
    }

    .blog-list-item {
      display: flex;
      margin-bottom: 40px;
      .blog-list-item-image {
        width: 160px;
        height: 108px;
        margin-right: 20px;
      }
      .blog-list-item-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
      }
      .item-right-title {
        color: #252629;
        font-family: 'PingFang SC';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 27px */
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 900px;
      }
      .item-right-content {
        color: var(--text-2, #5d5f65);
        font-family: 'PingFang SC';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 21px */

        // white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 45px;
      }
      .item-right-time-view {
        color: var(--text-3, #8f949d);
        font-family: 'PingFang SC';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 21px */
      }
    }
  }
}

@media (max-width: 980px) {
  .blog-list {
    padding: 40px 40px 0;
    box-sizing: border-box;
    margin: 0 auto;
    border-radius: 12px;
    margin-top: 100px;
    background: #f7f7f7;
  }

  .empty-image-box {
    padding: 40px 40px 0;
    box-sizing: border-box;
    margin: 0 auto;
    border-radius: 12px;
    margin-top: 400px;
    background: #f7f7f7;
    text-align: center;
    img {
      width: 320px;
      height: 320px;
    }
    span {
      display: block;
      color: var(---Text-1, #252629);
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 32px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 100% */
    }
  }

  .end {
    text-align: center;
    color: var(--text-3, #8f949d);
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 18px */
    margin-bottom: 20px;
  }

  .blog-list-item {
    display: flex;
    margin-bottom: 40px;
    background-color: #fff;
    padding: 20px;
    border-radius: 16px;
    .blog-list-item-image {
      width: 212px;
      height: 144px;
      margin-right: 24px;
    }
    .blog-list-item-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
    }
    .item-right-title {
      width: 350px;
      color: #252629;
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 27px */
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      height: 80px;
    }
    .item-right-time-view {
      color: var(--text-3, #8f949d);
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 21px */
    }
  }

  .blog-list-item:last-child{
    margin-bottom: 0;
  }
}
</style>
